import { createContext } from 'react';

import { TUserSimulationStatisticsDto } from '@app-velocity/av-api-v2';

export type UsageContextType = {
  simStatsByUser: TUserSimulationStatisticsDto | null;
  isLoading: boolean;
};

export const UsageContext = createContext<UsageContextType>({
  simStatsByUser: null,
  isLoading: true
});
